import { useCallback, useMemo } from 'react';

import { useOffers, OPTIMIZED_BASE_OFFERS_FILTER } from '@ocx/data-offers';

import { TutorialStorage } from '../../utils/TutorialStorage';
import { useHowDoesItWorkPopup } from '../../../../components/modals';

export interface IUseHowDoesItWorkProps {
  // Fetch base offers only when tutorial is not completed
  tutorialOnly?: boolean;
}

export const useHowDoesItWork = (props: IUseHowDoesItWorkProps = {}) => {
  const { tutorialOnly } = props;
  const { open: openHowDoesItWorkPopup } = useHowDoesItWorkPopup();

  // check if HowDoesItWork should be displayed on homepage or display on other pages
  const isHowDoesItWorkHidden = useMemo(
    () => (tutorialOnly ? !TutorialStorage.isHowDoesItWorkVisibleOnHomePage() : false),
    [tutorialOnly],
  );
  const { offers, loading } = useOffers({
    variables: OPTIMIZED_BASE_OFFERS_FILTER,
    skip: isHowDoesItWorkHidden,
  });
  const isHowDoesItWorkAvailable = !!offers.length;

  const handleHowDoesItWorkOfferClick = useCallback(() => {
    const marketingContentsWithTerms = offers.find(
      ({ marketingContent }) => marketingContent?.terms && marketingContent?.termsUrl,
    )?.marketingContent;
    return openHowDoesItWorkPopup({
      offers,
      terms: marketingContentsWithTerms?.terms,
      termsUrl: marketingContentsWithTerms?.termsUrl,
    });
  }, [offers, openHowDoesItWorkPopup]);

  return { handleHowDoesItWorkOfferClick, isHowDoesItWorkAvailable, loading, isHowDoesItWorkHidden };
};
